import LinkTab from '../components/shared-components/link_tab';
import "../css/styles.css";
import { connect } from 'react-redux';
import { setInfo } from '../redux/actionList';
import withRouterCompat from '../objects/CommonUse/with_router_compat';
import {Tooltip} from "@mui/material";
import ForParentsMain from '../components/for-parents/for_parents_main';
import LearningOverview from '../components/for-parents/learning_overview';
import ParentsGameInfo    from '../components/for-parents/parents_game_info';
import Footer from './footer';
//import {InputCompletedContext} from '../objects/Context/input_completed_context';
import React from 'react';
import {Link} from "react-router-dom";
import { setHeadersForFetch } from '../objects/CommonUse/set_headers_for_fetch';
import PlayersAndSettingsDisplay from '../components/for-parents/players_and_settings_display';
import CommentModal from '../components/shared-components/comment_modal';
import PlayerReports from '../components/for-parents/player_reports';
import WaitTimeSpinner from '../components/shared-components/wait_time_spinner';
import DiscussionTopics from '../components/for-parents/discussion_topics';
import {buildUrl } from '../objects/CommonUse/build_URL';
import Config from '../config';
import tooltipCommentIconText from './Text/tooltip_text';
import updateSessionTokenStorage from './Objects/update_session_token_storage';
import getCurrentDateTime from '../objects/CommonUse/get_current_date_time';
import ConfigFile from '../datasets/config_file';


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameData: state.gameData,
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};

class ForParents extends React.Component {
    constructor(props) {
        super(props);
       
    this.openCommentModal = this.openCommentModal.bind(this);
    this.closeCommentModal = this.closeCommentModal.bind(this);
       
     this.state = {
        inputArr: [
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false,
            },
            {
                completed: false,
                selected: false,
            },
           
        ],
        resetParentInfo: true,  
        headers: setHeadersForFetch(),
        commentIcon: "./assets/ContactUs/pencilPaper.png",
        commentModalOpen: false,
        fromProcessName: "ForParents",
        configurationAvailable: null,
        doneLoadingConfigs: false,
        userRole: sessionStorage.getItem("userRole"),
        screenSize: sessionStorage.getItem("GameScreenSize"),
        environment: Config.dataURL.currentEnv,
        subProcess: "forParents",
        rerender: false,
        parentInfo: {
            loading: true,
            gameData: {},
            savingsInfo: "",
            creditCardInfo: "",
            savingsLoaded: false,
            relatedPlayers: [],
            configsLoaded: false,
            accountInfo: "",
            accountLoaded: false,
            userListLoaded: false,
            accountList: [],
            accountListLoaded: false,
            nbrPrimarySignons: 0,
        }

    
    };
    this.accountIndividual = false;
    this.playerRoleOK = false;
    this.selected = "";
}

   
    onNavigate = (path) => {
        const { navigate, location } = this.props;

        const targetPath = `/${path}`;
        // Only navigate if we aren’t already there
        if (location.pathname !== targetPath) {
            navigate(`/${path}`, { replace: true });
        }
    };

           
    render(){
        this.parentInfoDisplay=this.getParentInfo();
        if (this.selected !== this.props.selected){
            updateSessionTokenStorage(this.props.selected);
            this.selected = this.props.selected;
        }
    return <>
        <span className="container m-0 p-0">
 
            {!this.parentInfoDisplay.userListLoaded  || !this.parentInfoDisplay.accountListLoaded ?
                <WaitTimeSpinner />
            :
            <span className="row w-100 mx-0">
                   
                        <div className="col-sm-2 mt-4 ">
                            <div>
                                <img  className="train-track-img" src={'./assets/ExtraCredit.png'} 
                                        alt="MoneyTrain"/>
                            </div>   
                        </div>
                  
                        <div>
                            <Tooltip title={tooltipCommentIconText} arrow >
                                <img src={this.state.commentIcon} 
                                    className={this.commentIconClass} alt="comment"
                                    onClick={this.openCommentModal}/>
                            </Tooltip>
                        </div>

                        {this.state.commentModalOpen ?
                            <CommentModal modalOpen={this.state.commentModalOpen} 
                                onClose={() => this.closeCommentModal()}
                                gamePart={this.state.fromProcessName}
                                processName={this.props.selected}
                                gameInfo = {() => this.getParentInfo()}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            />
                        :
                            null
                        }

                        {this.props.selected === "forParentsMain"  ?
                            <ForParentsMain 
                                goBack = {() => this.goToHomePage()}
                                onNavigate={(pathname) => this.onNavigate(pathname)}
                                onOpen ={()=> this.inputSelected(0)} /> 
                        : 
                            null
                        }
                       
                        {this.props.selected === "parentsGameInfo" ? 
                            <ParentsGameInfo
                                goBack = {() => this.goToHomePage()}
                                onOpen ={()=> this.inputSelected(1)}  /> 
                        : 
                            null
                        }
                           
                        {this.props.selected === "discussionTopics"  ?
                            <DiscussionTopics
                                playerRole={this.state.userRole}
                                goBack = {() => this.goToHomePage()}
                                onOpen ={()=> this.inputSelected(2)}
                                onInput={(index) => this.handleClick(index)}
                            />
                        :
                            null
                        }
                        
                        {this.props.selected === "learningOverview" ?
                            <LearningOverview
                                userRole={this.state.userRole}
                                goBack = {() => this.goToHomePage()}
                                onOpen ={()=> this.inputSelected(3)}
                                parentInfo = {() => this.getParentInfo()} 
                                setParentInfo = {(value, propertyName) => this.setParentInfo(value, propertyName)}
                                selected={this.props.selected}
                                configAvailable={this.state.configurationAvailable}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            />
                            
                        :
                            null
                        }
                      
                        {this.props.selected === "playerReports" ?
                            <PlayerReports
                                goBack = {() => this.goToHomePage()}
                                onOpen ={()=> this.inputSelected(4)}
                                parentInfo = {() => this.getParentInfo()} 
                                changeClassCode={(accountNbr) => this.changeClassCode(accountNbr)}
                                setParentInfo = {(value, propertyName) => this.setParentInfo(value, propertyName)}
                                selected={this.props.selected}
                                configAvailable={this.state.configurationAvailable}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            />
                            
                        :
                            null
                        }
                   
                          {this.props.selected === "relatedPlayers"  ?
                             <PlayersAndSettingsDisplay
                                goBack = {() => this.goToHomePage()}
                                onOpen ={()=> this.inputSelected(5)}
                                parentInfo = {() => this.getParentInfo()} 
                                setParentInfo = {(value, propertyName) => this.setParentInfo(value, propertyName)}
                                changeClassCode={(accountNbr) => this.changeClassCode(accountNbr)}
                                checkForConfigs = {() => this.checkForConfigs()}
                                getAccountList = {() => this.getAccountList()}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            /> 
                        : 
                            null
                        }

                    <div className="col-sm-2 mt-4"> 
                        <Link to="/for-parents-main" onClick={() => this.handleClick(0)}>
                            <LinkTab inputArr={this.state.inputArr[0]} name="Main Page" validToComplete="true" 
                                fiveTabs={true}/>
                        </Link>
                        <Link to="/parents-game-info" onClick={() => this.handleClick(1)}>
                            <LinkTab inputArr={this.state.inputArr[1]} name="Game Information" validToComplete="true" 
                                fiveTabs={true}/>
                        </Link>
                        <Link to="/discussion-topics" onClick={() => this.handleClick(2)}>
                            <LinkTab inputArr={this.state.inputArr[2]} 
                                name="Video Presentations" validToComplete="true" 
                                fiveTabs={true}/>
                        </Link>
                       
                       {!this.state.inputArr[3].completed ?
                            <Link to="/learning-overview" onClick={() => this.handleClick(3)}>
                                <LinkTab inputArr={this.state.inputArr[3]} 
                                    name="Learning Overview" validToComplete="true" 
                                   fiveTabs={true}/>
                            </Link>
                        :
                            <LinkTab inputArr={this.state.inputArr[3]} name="Learning Overview" 
                                fiveTabs={true}/>
                        }

                        {!this.state.inputArr[4].completed ?
                            <Link to="/player-reports" onClick={() => this.handleClick(4)}>
                                <LinkTab inputArr={this.state.inputArr[4]} 
                                    name="Player Reports" validToComplete="true" 
                                    fiveTabs={true}/>
                            </Link>
                        :
                            <LinkTab inputArr={this.state.inputArr[4]} name="Player Reports" 
                                fiveTabs={true}/>
                        }

                        {!this.state.inputArr[5].completed ?
                            <Link to="/related-players" onClick={() => this.handleClick(5)}>
                                <LinkTab inputArr={this.state.inputArr[5]} name="Players and Settings" validToComplete="true" 
                                   fiveTabs={true}/>
                            </Link>
                        :
                            <LinkTab inputArr={this.state.inputArr[5]} name="Players and Settings" 
                                fiveTabs={true}/>
                        }
                        {(this.state.screenSize === "zoom") &&
                            <Footer 
                                screenSize={this.state.screenSize}
                            />
                        }
                      
                    </div>
            {/*
                      {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
            */}
                 </span>  
            }
        </span>
    </>
}

componentDidMount(){
    this._isMounted = true;
    const gameData = this.props.gameData;
    this.setParentInfo(gameData, 'gameData');
    this.inputSelected(0);
    switch(this.props.selected) {
        case "forParentsMain":
            this.inputSelected(0);
            break;
        case "parentsGameInfo":
            this.inputSelected(1);
            break;
        case "discussionTopics":
            this.inputSelected(2);
            break;
        case "learningOverview":
            this.inputSelected(3);
            break;
        case "playerReports":
            this.inputSelected(4);
            break;
        case "relatedPlayers":
            this.inputSelected(5);
            break;
        default:
            break;
    }
      this.componentStartup();    
}
       
inputSelected = (inputID) => {
    let inputArr = this.state.inputArr;
    for (const input of inputArr) {
        input.selected = false;
    }
    inputArr[inputID].selected = true;
    if (this._isMounted === true){
        this.setState({inputArr: inputArr}); 
    }
};

componentStartup(){
    this.accountNbr = sessionStorage.getItem("userAccountNbr");
    if (this.state.userRole === "parent" || this.state.userRole === "teacher" ||
        this.state.userRole === "autoPlayer" || this.state.userRole === "demo" ||
        (this.state.userRole === "player" && this.accountNbr === "Individual")){
            //  these individuals have access to all buttons in the ForParents/Teachers page
            if (this.state.userRole === "player"){
                this.accountNbr = ConfigFile.general.demoAccount;
            }
    }else{
        let inputArr = this.state.inputArr;
        inputArr[3].completed = true;
        inputArr[4].completed = true;
        inputArr[5].completed = true;
        this.setState({inputArr: inputArr});
    }
   
    this.getPlayerAccount(this.accountNbr);
    sessionStorage.setItem("rptAccountNbr", this.accountNbr);
    if (this.state.userRole === "teacher"){
        this.getAccountList();
    }else{
        this.setParentInfo(true, 'accountListLoaded');
    }
    
    if (this.state.screenSize === "zoom" ||
        this.state.screenSize === "narrow"
    ){
            this.commentIconClass = "comment-icon-position comment-img";
    }else{
            this.commentIconClass = "for-parents-comment-icon-position comment-img"; 
    }
}

changeClassCode(accountNbr){
    this.setParentInfo(false, "accountLoaded");
    this.setParentInfo(false, "userListLoaded");    
    this.getPlayerAccount(accountNbr);
    sessionStorage.setItem("userAccountNbr", accountNbr);
}

componentWillUnmount(){
    this.props.setInfoRedux("for-parents-main", "prevProcess");
    this._isMounted = false;
}

getPlayerAccount(accountNbr){
    const funcName = "loadAccount";
    const urlParm = "?accountNbr=" + accountNbr + "&test=test";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.getUserList(accountNbr);
                        this.setParentInfo(output.body, "accountInfo");
                        this.setParentInfo(true, "accountLoaded");
                    }else{  
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
}

getUserList(accountNbr){
    const funcName = "userCollectionList";
    const urlParm = "?accountNbr=" + accountNbr + "&test=test";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.processUserList(output.body);
                        this.setParentInfo(true, "userListLoaded");    
                    }else{  
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
}

processUserList(data) {
    let userName = sessionStorage.getItem("username");
    let userArr = data;
    if (this.accountNbr === ConfigFile.general.demoAccount){
        this.playerRoleOK = true;
    }else{
        for (let i=0; i<userArr.length; i++){
            if (userArr[i].username === userName && 
                (userArr[i].role === "teacher" || userArr[i].role === "parent" ||
                 userArr[i].role === "autoPlayer" || userArr[i].role === "demo")){
                    this.playerRoleOK = true;
                    break;
            }
        }
    
    }
    this.buildPlayerArr(userArr);
}
  
buildPlayerArr(data){
    let playerArr = [];
    let nbrPrimary = 0;
    if (this.playerRoleOK === true){
        let userArr = data;
        for (let i=0; i<userArr.length; i++){
            if (userArr[i].role === "player"){
                   playerArr.push(userArr[i].username);
            }else{
                 nbrPrimary += 1;
            }
        }
     }
     this.setParentInfo(playerArr, "relatedPlayers");
     this.setParentInfo(nbrPrimary, "nbrPrimarySignons");
}
  
loadGame()
{
    const funcName = "loadGame";
    const urlParm = "?mode=fullLoad";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                       
                        this.setParentInfo(false, 'loading');
                    }else{  
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
}

getAccountList() {
    // retrieve all accounts where userName is an accountOwner
    const userName = sessionStorage.getItem("username");
    const funcName = "loadAccountList";
    const urlParm = "?userName=" + userName;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        const accountList = this.createAccountList(output.body, userName);
                        this.setParentInfo(accountList, 'accountList');
                        this.setParentInfo(true, 'accountListLoaded')
                    }else{  
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
}

createAccountList(accountList, userName){
    let accountListArr = [];
    const dateTime = getCurrentDateTime();
    //  add the 'demo account to the list
    const demoAccountObj = {accountNbr: ConfigFile.general.demoAccount, className: "Demonstration class.",
        dateAssigned: "2021/01/01"}
    accountListArr.push(demoAccountObj);
    
    for (let i=0; i<accountList.length; i++){
        const teacherObj = accountList[i].accountOwnerArr.find(elem => elem.username === userName);
        let dateAssigned = dateTime.date;
        if (teacherObj){
              dateAssigned = teacherObj.dateUpdated;
        }
        const accountListObj = {accountNbr: accountList[i].accountNbr, className: accountList[i].className,
            dateAssigned: dateAssigned}
        accountListArr.push(accountListObj);
    }
    return accountListArr;
}
 
openCommentModal(){
    this.setState({commentModalOpen: true});
}

closeCommentModal(){
    this.setState({commentModalOpen: false});
}

handleClick = index => {
    this.inputSelected(index);
}

getParentInfo()
{
    return this.state.parentInfo;
}

setParentInfo(value, propertyName = null)
{
    if (propertyName)
    {
        let parentInfo = this.state.parentInfo;
        parentInfo[propertyName] = value;
        this.setState({parentInfo: parentInfo});
    }
    else this.setState({parentInfo: value});
              
}

goToHomePage(){
    this.onNavigate("");
}

processErrorReturn(errorObj){
    this.addRecordToLogfile(errorObj);
    if (!errorObj.silentAlert || errorObj.silentAlert === false){
        alert ("Uh oh!  Something unexpected has occurred " +
            "error has been logged and will be addressed. " +
            "For now click OK, then return to the process " +
            "where you were and try again.");
        this.onNavigate("");
    }
}

addRecordToLogfile(errorObj){
    const headers=setHeadersForFetch();
    if (errorObj.status === 250){
        errorObj.message = "No record found";
    }
    let subProcess = "";  
    if (!errorObj.subProcess){
        subProcess = "unknown"
    }else{
        subProcess = errorObj.subProcess;
    }
    if (!errorObj.errorObject){
        errorObj.errorObject = {};
    }
    const logFileBody =  {
        mainProcess: "ForParents",
        subProcess: subProcess,
        function: errorObj.function,
        status: errorObj.status,
        message: errorObj.message,
        errorObj: errorObj.errorObject
    }
    console.log("logFileBody is: ", logFileBody)
    const urlParm = "";
    const uri = buildUrl(this.state.environment, "saveLogFile", urlParm);
    fetch (uri,  
        {method:'POST',
            headers: headers,
            body: JSON.stringify(logFileBody)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        console.log("logfile create was successful");
                    }else{
                        console.log("Response from save log file not valid!" +
                        " status is: ", output.statusCode,
                        " message is: ", output.body);
                        alert ("Response from save log file not valid!");
                           
                    }
            });
        }
    });
  
}

}

export default connect(mapStateToProps, mapDispatchToProps)(withRouterCompat(ForParents));